import { ReactNode } from 'react';
import { useAuth } from './Auth.hooks';

export const Auth = ({ children }: AuthProps) => {
	const { isAuthenticated, isLoading } = useAuth();
	if (!isAuthenticated) {
		return null;
	}
	if (isLoading) {
		return null;
	}
	return <>{children}</>;
};

interface AuthProps {
	children: ReactNode;
}
